/* rr-cart.js — AJAX add-to-cart que abre el cart-drawer nativo de Dawn */
(function () {
  'use strict';

  function addToCart(form, btn) {
    var cartDrawer = document.querySelector('cart-drawer');
    var data = new FormData(form);
    // Pedir las secciones que Dawn necesita para refrescar el drawer
    if (cartDrawer) {
      data.append('sections', 'cart-drawer,cart-icon-bubble');
      data.append('sections_url', window.location.pathname);
    }
    var original = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.innerHTML = '...'; }

    fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: data
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status) { // error (e.g. sold out)
          if (btn) { btn.innerHTML = 'Agotado'; }
          return;
        }
        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          cartDrawer.classList.remove('is-empty');
          cartDrawer.renderContents(res);
          if (typeof cartDrawer.open === 'function') cartDrawer.open();
        } else {
          window.location = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart';
        }
        if (btn) { btn.innerHTML = '✓ Agregado'; }
      })
      .catch(function () {
        window.location = '/cart';
      })
      .finally(function () {
        if (btn) setTimeout(function () { btn.disabled = false; btn.innerHTML = original; }, 1400);
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('.rr-add-form');
    if (!form) return;
    e.preventDefault();
    addToCart(form, form.querySelector('[type=submit]'));
  });

  // Sticky add-to-cart bar en página de producto
  document.addEventListener('DOMContentLoaded', function () {
    var sticky = document.querySelector('.rr-sticky');
    var anchor = document.querySelector('.rr-sticky-anchor') || document.querySelector('product-info') || document.querySelector('.product__info-wrapper');
    if (!sticky || !anchor) return;
    var io = new IntersectionObserver(function (entries) {
      sticky.classList.toggle('is-on', !entries[0].isIntersecting);
    }, { rootMargin: '0px 0px -80% 0px' });
    io.observe(anchor);
  });
})();
